import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Counter } from './Counter'; // Adjust import path if needed

export const Competence: React.FC = () => (
    <>
        <Typography
            variant="overline"
            color="text.secondary"
        >
            Unsere kompetenz in Zahlen
        </Typography>
        <Grid container spacing={{ xs: 6, sm: 4 }} justifyContent="center" sx={{ mb: 6 }}>
            <Grid size={{ xs: 12, sm: 4 }}>
                <Counter label="betreute Mandate" target={416} suffix=" +" />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <Counter label="Jahre Erfahrung" target={new Date().getFullYear() - 2021} />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <Counter label="erfolgsorientierte Vertretung" target={100} suffix="%" />
            </Grid>
        </Grid>
        <Typography
            variant="h4"
            fontWeight={700}
            sx={{ textAlign: 'center' }}
        >
            Erfahrung. Vertrauen. Erfolg.
        </Typography>
    </>
);
